export default __webpack_public_path__ + "static/imgThirteen-b676dd0196f998be5815aa5ea2a9087e.jpg";